import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Expeditor = () => {
    document.title = "Distributor";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Distributorlar", value: "/expeditors" },
        { name: "Distributor", value: "/expeditors/expeditor", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Distributor (Ekspediterlər)</h2>
                    <p>
                        Distributor (Ekspediterlər) səhifəsində sahibkara olan <mark>ümumi borc</mark>, <mark>anbar qalığı</mark> (səyyar anbar),{" "}
                        <mark>alacaq borclar</mark> (nisyələr) və <mark>balans</mark> əks olunur.
                        <ul>
                            <li>
                                Əgər Distributor (ekspediter) adının üzərinə tıklasaq açılan pəncərədə həmin Distributor (ekspediter) ilə qarşılıqlı hesabat
                                görünəcək
                            </li>
                            <li>Əgər anbar qalığı üzərinə tıklasaq açılan pəncərədə Distributorin (ekspediter) anbar qalığı əks olunacaq</li>
                            <li>Balans, Distributorə (ekspediter) olan pulun göstəricisidir</li>
                        </ul>
                        <br />
                        Nümunədə Distributorlar ⮞ Distributor səhifəsinə keçid göstərilib.
                    </p>
                    <img src="/images/expeditors/expeditor-1.gif" alt="Distributor" />
                    <p>
                        <b>Alacaq borc</b> üzərinə tıklasaq, açılan pəncərədə borclar barədə məlumatlar əks olunacaq. Açılmış pəncərədə tərəf müqabil adının
                        üstünə tıklasaq, həmin tərəf müqabil ilə ümumi borcun formalaşmasına səbəb olan bütün əməliyyatlar istifadəçiyə təqdim olunacaq. (
                        Üzləşmə aktı )
                        <br />
                        Nümunədə Distributorlar ⮞ Üzləşmə aktına keçid göstərilib.
                    </p>
                    <img src="/images/expeditors/expeditor-2.gif" alt="Distributor" />
                </article>
            </div>
        </div>
    );
};
